<form #policyRuleForm="ngForm" (ngSubmit)="isFormValid() && save()">
    <div class="mon-dialog-body-with-footer auto-scroll policy-form-dialogs-rule px-3">
        <div class="form-group mt-4"
             [ngClass]="{'has-error': policyRuleForm.form.get('name')?.invalid && (policyRuleForm.form.get('name')?.dirty || policyRuleForm?.submitted)}">
            <label for="rule_name" class="col-form-label text-bold"><span translate>Rule name</span>*</label>
            <input id="rule_name"
                   data-test="rule-name"
                   name="name"
                   type="text"
                   [(ngModel)]="cRule.name"
                   required
                   class="form-control"/>
            <form-field-errors [input]="policyRuleForm.name" offset="0"></form-field-errors>
        </div>

        <div class="form-group mt-2 sub-entries" *ngIf="subEntry?.options?.length > 0">
            <label class="col-form-label text-bold">{{subEntry.labelTxt}}</label><br/>

            <label class="checkbox-inline inline-block">
                <input type="checkbox" [checked]="areAllSubEntriesSelected"
                       (click)="selectAllSubEntries()"/>
                {{subEntry.allTxt}}
            </label>
            <form-field-checkbox-in-line (ngModelChange)="checkSelectedSubEntries()" class="inline-block"
                                         name="subEntryCheckbox"
                                         [options]="subEntry.options" returnValue="value"
                                         [(ngModel)]="cRule.sub_entry">
            </form-field-checkbox-in-line>
        </div>

        <div class="form-group mt-5" [ngClass]="{'has-error': policyRuleForm.form.get('query')?.invalid && (policyRuleForm.form.get('query')?.dirty || policyRuleForm?.submitted)}">
            <label for="query" class="col-form-label text-bold" translate>Search for content that*</label>:
            <div class="input-group">
                <mon-action-menu
                       class="rule-menu-action"
                       *ngIf="cRule.operator"
                       [monActionMenuItems]="dropdownOptions"
                       [monActionMenuClass]="'menu-panel-left-align'">
                    {{selectedOption?.translation}}
                </mon-action-menu>
                <input name="query"
                       id="query"
                       [(ngModel)]="cRule.query"
                       required
                       class="form-control"
                       type="text"/>
            </div>
            <div *ngIf="getOperatorHelpBlock().length > 0" class="help-block">
                {{getOperatorHelpBlock()}}
            </div>
            <form-field-errors [input]="policyRuleForm.form.get('query')" offset="0"></form-field-errors>
        </div>

        <div class="form-group mt-4"
             *ngIf="cRule.operator === 'conforms_with'"
             [ngClass]="{'has-error': policyRuleForm.form.get('sub_entry')?.invalid && (policyRuleForm.form.get('sub_entry')?.dirty || policyRuleForm?.submitted)}">
            <label class="col-form-label text-bold" for="sub_entry" translate>and does not conform with</label>:
            <input name="sub_entry"
                   [(ngModel)]="cRule.sub_entry"
                   class="form-control">
            <form-field-errors [input]="policyRuleForm.form.get('sub_entry')" offset="0"></form-field-errors>
        </div>

        <form-field-radio-in-line
                *ngIf="cRule.operator !== 'conforms_with'"
                class="block mt-4"
                name="ruleInverse"
                [(ngModel)]="cRule.inverse"
                [options]="inverseOptions"
                returnValue="value"
                [helpTxt]="'Do you want to find pages which match the query or pages which does not match the query' | translate">
        </form-field-radio-in-line>

        <form-field-radio-in-line
                class="block mt-4"
                *ngIf="cRule.operator === 'regex'"
                [(ngModel)]="cRule.multiline"
                name="ruleOperator"
                [options]="multilineOptions"
                returnValue="value"
                [helpTxt]="'Do you want to find pages which match the query on one or multiple lines?' | translate">
        </form-field-radio-in-line>

        <div class="form-group mt-5">
            <label class="col-form-label text-bold" translate>Case sensitivity</label>
            <form-field-radio-in-line *ngIf="isSudo"
                name="caseSensitive"
                [(ngModel)]="cRule.case_sensitive"
                [options]="caseSensitiveOptions"
                [helpTxt]="'Select whether the rule should search for case sensitive text or not' | translate"
                returnValue="value">
            </form-field-radio-in-line>

            <p *ngIf="!isSudo && cRule.name && cRule.case_sensitive === false" translate>
                <span class="fas fa-exclamation-triangle secondary-15"></span>
                This rule is outdated (not case-sensitive) and therefore can’t be edited. Please create a new rule if you wish to change its values.
            </p>

            <p *ngIf="!isSudo && cRule.case_sensitive" translate>
                <span class="fas fa-exclamation-circle blue-main-1"></span>
                Please remember that every rule behaves as case-sensitive!
            </p>
        </div>



        <div class="form-group mt-4"
             *ngIf="cRule.type === 'page_html'"
             [ngClass]="{'has-error': policyRuleForm.form.get('css_filters')?.invalid && (policyRuleForm.form.get('css_filters')?.dirty || policyRuleForm?.submitted)}">
            <p class="text-bold mt-2 mb-0" translate>Limit or exclude</p>
            <span translate>
                Add CSS selectors to either limit the search within those values or exclude the snippets with the given inputs.
                You can add as many selectors as you wish.
            </span>
            <span [ngbTooltip]="'Make sure you use the correct setting' | translate"
                  [triggers]="'focus hover'"
                  placement="right"
                  class="fas fa-question-circle"
                  [attr.aria-label]="'Make sure you use the correct setting' | translate">
            </span>

            <div class="row mt-2 mb-0 css_examples">
                <div class="col-10">
                    <p class="text-bold mb-0" translate>Example 1</p>
                    <span>
                        <code>.class-name1</code>
                    </span>
                </div>
                <div class="col-10">
                    <p class="text-bold mb-0" translate>Example 2</p>
                    <span>
                        <code>#idname</code>
                    </span>
                </div>
                <div class="col-10">
                    <p class="text-bold mb-0" translate>Example 3</p>
                    <span>
                        <code>div.container#main</code>
                    </span>
                </div>
                <div class="col-10">
                    <p class="text-bold mb-0" translate>Example 4</p>
                    <span>
                        <code>a[href^="https"]</code>
                    </span>
                </div>
            </div>

            <div class="form-group row align-items-top mt-2 mb-0" *ngFor="let filterType of cssFilters; trackBy: cssFiltersTrackFn; let i = index">
                <div class="col-sm-16">
                    <form-field-select
                        [(ngModel)]="filterType.name"
                        [options]="filterTypeOptions"
                        [name]="'filterTypeName_' + i"
                        nameAttr="name"
                        [removeButton]="false"
                        [required]="cssFilters.length > 1"
                        returnValue="value">
                    </form-field-select>
                </div>
                <label class="col-form-label col-sm-2 ml-2 p-0 mt-2" translate>Value:</label>
                <div class="col-sm-25 pl-0">
                    <input [(ngModel)]="filterType.value"
                           [name]="'css_filters_' + i"
                           [id]="'css_filters_' + i"
                           class="form-control full-height"
                           [attr.placeholder]="'Insert a CSS selector' | translate"
                           [attr.aria-label]="'Insert a CSS selector' | translate"
                           data-test="css-selector-input"
                           type="text"/>
                    <p class="mt-1 text-danger"
                       *ngIf="filterType.value && !isSelectorValid(filterType.value)"
                       translate>
                        Enter a valid CSS selector
                    </p>
                </div>
                <div class="col-sm-4 p-0">
                    <button type="button"
                            [ngbTooltip]="'Remove row' | translate"
                            class="btn btn-border-radius btn-secondary full-height"
                            (click)="removeFilterType(i)">
                        <span class="text-link fas fa-trash-alt"></span>
                        <span class="sr-only" translate>Remove row</span>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-40 mt-2">
                    <button type="button"
                            class="btn btn-border-radius btn-secondary full-height"
                            (click)="addFilterType()">
                        <span class="fas fa-plus text-link"></span>
                        <span class="sr-only" translate>Add row</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="mon-dialog-footer">
        <div class="row">
            <div class="col-48 text-right">
                <button type="submit"
                        [disabled]="policyRuleForm?.invalid"
                        class="btn btn-border-radius btn-secondary"
                        translate>
                    Save
                </button>
            </div>
        </div>
    </div>
</form>
